import React from "react";
import ReactDOMClient from "react-dom/client";
import singleSpaReact from "single-spa-react";
import Root from "./root.component";

const lifecycles = singleSpaReact({
  React,
  ReactDOMClient,
  rootComponent: Root,
  errorBoundary(err, info, props) {
    // Customize the root error boundary for your microfrontend here.
    return null;
  },
});

export const { bootstrap, mount, unmount, update } = lifecycles;

export const options = `
  type Props {
    theme: String

    data: [Task]
  }

  type Task {
    id: ID
    start: DateTime
    end: DateTime

    children: [Task]

    name: String
    color: String
    opacity: Float
  }
`;
